import {
  FETCH_DOCUMENT_COLLABORATION,
  FETCH_DOCUMENT_COLLABORATION_SUCCESS,
} from '../actions/DocumentCollaborationActions';

const initialState = {
  data: {},
  loading: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DOCUMENT_COLLABORATION:
      return {
        ...state,
        loading: true,
      };
    case FETCH_DOCUMENT_COLLABORATION_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        data: action.payload.data,
      };
    default:
      return state;
  }
};
